import api from "~services/axios";

export default {
  apiGetProjectList: params => api.post("/api/project/query", params),
  apiGetCrmProjectList: params =>
    api.get("/api/crmProjectManagement/queryList", { params }),
  apiGetProjectDetail: params => api.get("/api/project/detail", params),
  apiGetQueryTeam: params => api.get("/api/project/queryteam", params),
  apiGetProjectSelect: params => api.get("/api/project/dropDownProjectQuery"),
  apiGetCustomerSelect: params =>
    api.get("/api/project/dropDownCustomerQuery", params),
  apiGetContractSelect: params =>
    api.get("/api/project/dropDownContractQuery", params),
  apiGetSalesmanSelect: params => api.get("/api/project/querySalesman", params),
  apiDeleteProject: params => api.post("/api/project/delete", params),
  apiAddProject: params => api.post("/api/project/add", params),
  apiUpdateProject: params => api.post("/api/project/update", params),
  apiGetPackage: params => api.get("/api/project/queryPackage", params),
  apiExport: params => api.post("/api/project/export", params),
  apiCrmExport: params => api.post("/api/crmProjectManagement/export", params),
  // 项目详情查看权限(pmo侧权限)获取
  listProjectAuth: params =>
    api.get("/api/crmProjectManagement/listProjectAuth", { params }),
  // crm项目详情
  queryCrmProjectDetail: params =>
    api.get("/api/crmProjectManagement/queryProjectDetail", { params }),
  // 项目详情-项目基本信息查询
  queryBasicInfo: params =>
    api.get("/api/crmProjectManagement/queryBasicInfo", { params }),
  // 里程碑
  queryProjectMilestone: params =>
    api.get("/api/crmProjectManagement/queryProjectMilestone", { params }),
  // 关键任务
  queryProjectKeyTask: params =>
    api.get("/api/crmProjectManagement/queryProjectKeyTask", { params }),
  // 变更管理
  queryProjectChangeManage: params =>
    api.get("/api/crmProjectManagement/queryProjectChangeManage", { params }),
  // 项目问题
  queryProjectProblem: params =>
    api.get("/api/crmProjectManagement/queryProjectProblem", { params }),
  // 项目风险
  queryProjectRisk: params =>
    api.get("/api/crmProjectManagement/queryProjectRisk", { params }),
  // 所需支持
  queryProjectSupport: params =>
    api.get("/api/crmProjectManagement/queryProjectSupport", { params }),
  // 干系人
  queryProjectStakeholder: params =>
    api.get("/api/crmProjectManagement/queryProjectStakeholder", { params }),
  // 项目成员
  queryProjectMember: params =>
    api.get("/api/crmProjectManagement/queryProjectMember", { params }),
  // 项目状态获取
  queryProjectStatus: params =>
    api.get("/api/crmProjectManagement/queryProjectStatus", { params }),
  // 商机详情-已有项目查询
  queryVisibleProject: params =>
    api.get("/api/crmProjectManagement/queryVisibleProject", { params }),
  // 项目查看详情权限接口（pmo侧权限）
  queryProjectDetailAuth: params =>
    api.get("/api/crmProjectManagement/queryProjectDetailAuth", { params }),
  // 获取OA token
  getOaToken: params =>
    api.get("/api/crmProjectManagement/getOaToken", { params }),
  // 获取OA登录token
  getOaTokenInside: params =>
    api.get("/api/common/getOaToken", { params }),
};
